import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumVesselTypeIcon implements BaseEnumType {
  private static allValues: EnumVesselTypeIcon[] = []; // make sure this is top-most
  
  public static cylindrocononical = new EnumVesselTypeIcon(0, "Cylindrocononical", "enum_vessel_type_icon_cylindrocononical");
  public static inverseCylindrocononical = new EnumVesselTypeIcon(1, "InverseCylindrocononical", "enum_vessel_type_icon_inverse_cylindrocononical");
  public static mashTun = new EnumVesselTypeIcon(2, "MashTun", "enum_vessel_type_icon_mash_tun");
  public static cylindrical = new EnumVesselTypeIcon(3, "Cylindrical", "enum_vessel_type_icon_cylindrical");
  public static barrel = new EnumVesselTypeIcon(4, "Barrel", "enum_vessel_type_icon_barrel");
  public static still = new EnumVesselTypeIcon(5, "Still", "enum_vessel_type_icon_still");
  public static rectangle = new EnumVesselTypeIcon(6, "Rectangle", "enum_vessel_type_icon_rectangle");
  public static oval = new EnumVesselTypeIcon(7, "Oval", "enum_vessel_type_icon_oval");
  public static square = new EnumVesselTypeIcon(8, "Square", "enum_vessel_type_icon_square");
  public static circle = new EnumVesselTypeIcon(9, "Circle", "enum_vessel_type_icon_circle");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVesselTypeIcon.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isCylindrocononical() { return this === EnumVesselTypeIcon.cylindrocononical; }
  public isInverseCylindrocononical() { return this === EnumVesselTypeIcon.inverseCylindrocononical; }
  public isMashTun() { return this === EnumVesselTypeIcon.mashTun; }
  public isCylindrical() { return this === EnumVesselTypeIcon.cylindrical; }
  public isBarrel() { return this === EnumVesselTypeIcon.barrel; }
  public isStill() { return this === EnumVesselTypeIcon.still; }
  public isRectangle() { return this === EnumVesselTypeIcon.rectangle; }
  public isOval() { return this === EnumVesselTypeIcon.oval; }
  public isSquare() { return this === EnumVesselTypeIcon.square; }
  public isCircle() { return this === EnumVesselTypeIcon.circle; }

  public static getValues(): readonly EnumVesselTypeIcon[] {
    return EnumVesselTypeIcon.allValues;
  }

  public static getValuesExcept0(): readonly EnumVesselTypeIcon[] {
    return EnumVesselTypeIcon.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVesselTypeIcon {
    const found = EnumVesselTypeIcon.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVesselTypeIcon - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVesselTypeIcon): EnumVesselTypeIcon {
    const found = name ? EnumVesselTypeIcon.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVesselTypeIcon - Value not found: ${ name }`);
    }

    return found;
  }
}